import { createReducer } from "redux-create-reducer";
import {
  CHANGE_USERNAME,
  CHANGE_PASSWORD,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  AUTH_REQUEST,
  SIGN_IN,
  SIGN_OUT,
  CREATING_USER,
} from "./../actions/auth";

const initialState = {
  authenticated: false,
  loading: false,
  username: "",
  password: "",
  creatingUser: false,
};

export default createReducer(initialState, {
  [CHANGE_USERNAME](state, action) {
    return {
      ...state,
      username: action.payload.username,
    };
  },
  [CHANGE_PASSWORD](state, action) {
    return {
      ...state,
      password: action.payload.password,
    };
  },
  [SIGN_IN](state) {
    return {
      ...state,
      error: undefined,
      loading: true,
    };
  },
  [SIGN_OUT]() {
    return {
      authenticated: false,
    };
  },
  [AUTH_SUCCESS](state) {
    return {
      ...state,
      error: undefined,
      loading: false,
      authenticated: true,
      creatingUser: false,
    };
  },
  [AUTH_FAILURE](state, action) {
    return {
      ...state,
      error: action.payload.error,
      loading: false,
      authenticated: false,
      creatingUser: false,
    };
  },
  [CREATING_USER](state, action) {
    return {
      ...state,
      creatingUser: true,
    };
  },
});
